export default __webpack_public_path__ + "static/media/Helm of the Dauntless.6c307094.jpg";